//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"DmlExtension",1,0],[0,"DmlPcs",1,0],[0,"DrfTransform",1,0],[0,"FeatureDetail",1,0],[0,"FeatureSummary",1,0],[0,"ListOutput",1,0],[0,"OutputFile",1,0],[0,"OutputFormat",1,0],[0,"PointDetail",1,0],[0,"ReportHeader",1,0],[0,"ReportingCsys",1,0],[0,"TextExtension",1,0],[0,"ToleranceDetail",1,0],[0,"ToleranceSummary",1,0]],[[[],"OutputText",{},0,0],[[],"OutputDml",{},0,0],[["nOps"],"GetSelectedOps",{R_:{selectedOps:""}},0,0],[["selectedOps"],"SetSelectedOps",{},1,0]],[]];
SPLM.CAM.InspectionAnalyzeOutputBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionAnalyzeOutputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionAnalyzeOutputBuilder.OutputFormatType = Object.freeze({
    "StandardTextListing" : "StandardTextListing", "DimensionalMarkupLanguage" : "DimensionalMarkupLanguage", "Pdf" : "Pdf"});

SPLM.CAM.InspectionAnalyzeOutputBuilder.ReportingCsysType = Object.freeze({
    "Pcs" : "Pcs", "Drf" : "Drf", "SetupABS" : "SetupABS", "PartABS" : "PartABS"});

export default SPLM;